var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.25C0 1.00736 1.00736 0 2.25 0H7.6287C8.2254 0 8.79772 0.237053 9.21968 0.65901L11.341 2.78033C11.7629 3.20229 12 3.77459 12 4.37132V12.75C12 13.9927 10.9927 15 9.75 15H2.25C1.00736 15 0 13.9927 0 12.75V2.25ZM2.25 1.5C1.83579 1.5 1.5 1.83579 1.5 2.25V12.75C1.5 13.1642 1.83579 13.5 2.25 13.5H9.75C10.1642 13.5 10.5 13.1642 10.5 12.75V4.37132C10.5 4.17241 10.4209 3.98164 10.2803 3.84099L8.15903 1.71967C8.01832 1.57902 7.8276 1.5 7.6287 1.5H2.25ZM3 6C3 5.58579 3.33579 5.25 3.75 5.25H8.25C8.66422 5.25 9 5.58579 9 6C9 6.41423 8.66422 6.75 8.25 6.75H3.75C3.33579 6.75 3 6.41423 3 6ZM3 9C3 8.58578 3.33579 8.25 3.75 8.25H6.75C7.16423 8.25 7.5 8.58578 7.5 9C7.5 9.41422 7.16423 9.75 6.75 9.75H3.75C3.33579 9.75 3 9.41422 3 9Z",
    fill: "currentFill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/fileIcon.5f572dd265e454d17a8117dd260be0a4.svg";
export { ForwardRef as ReactComponent };